module.exports = __webpack_public_path__ + "static/media/edit.a4344b07.png";